export class ContractDetailsResources {
  public readonly contractNumber: string = 'Номер договора';
  public readonly createdDate: string = 'Договор оформлен';
  public readonly expireDate: string = 'Окончание договора';
  public readonly productType: string = 'Тип продукта';
  public readonly percentInYear: string = 'Процентная ставка';
  public readonly initialFee: string = 'Первоначальный взнос';
  public readonly peerMontFee: string = 'Ежемесячный платеж';
  public readonly creditAmount: string = 'Сумма договора';
  public readonly contractDetails: string = 'Детали договора';
  public readonly yearlyPercent: string = '% годовых';
  public readonly monthlyPercent: string = '% в месяц';
  public readonly attention: string = 'Отказаться от договора?';
  public readonly textAttentionRemoving: string =
    'Сомневаетесь в оформлении? Мы поможем разобраться с условиями и завершить процесс. Закажите консультацию прямо сейчас.';
  public readonly refuse: string = 'Отказаться от договора';
  public readonly orderConsultation: string = 'Заказать консультацию';
  public readonly finalPayment: string = 'Сумма полного досрочного погашения';
  public readonly currentPayment: string = 'Сумма очередного платежа';
  public readonly cancelContract: string = 'Отказаться от договора';
  public readonly contract: string = 'Договор';
  public readonly contractRead: string = 'Читать';
  public readonly reasonForDeleting: string =
    'Укажите причину отказа от договора';
  public readonly amountOfNextPayment: string = 'Сумма очередного платежа';
  public readonly restOfPaymentSchedule: string = 'Остаток графика платежей';
  public readonly madePayments: string = 'Внесенные платежи';
}
